import React from 'react';

import { AppIconGroupProps } from './app-icon.types';

export const AppIconGroup: React.FC<AppIconGroupProps> = (props) => {
  const { children } = props;

  return <div className='flex gap-1'>{children}</div>;
};
